<template>
	<div class="content">
		<div class="container">
			<!-- <h2>2021-2022</h2> -->
			<div class="uwaa-btn-wrapper"><a class="uwaa-btn btn-slant-left btn-purple" href="https://www.washington.edu/financialaid/getting-started/">⇦ Return to Getting started</a></div>
			<p>We know many families are concerned about their ability to pay for college. This estimator service will give you an estimate of the type and amount of aid undergraduate students in similar financial situations as yours have received to attend the UW.
			<p><strong>Did you know?</strong></p>
			<ul><li style="margin-bottom: 0;">The University of Washington gives out about $400 million in financial aid to undergraduate students per year.</li>
				<li>Over 52% of our students receive some form of financial aid.</li></ul>
			<p><strong>This is an estimate only and NOT a promise of an award to you.</strong> Many factors go into deciding what award a student receives and these can change from year to year, such as the funding we have available from state, federal, and institutional sources, the federal expected family contribution formulas, the relative amount of need of all the students at the UW, and the cost to attend the UW.</p>

			<div class="section-label">Student Information</div>
			<p><strong>Note:</strong> When entering amounts, please do not use commas.</p>
			<ol><li><label for="efc"><strong>Your <a href="http://apps.osfa.washington.edu/expected-family-contribution/dependancy-calc/?_ga=2.231312543.1601291037.1700680320-121307629.1686079790" target="_blank">Expected Family Contribution</a> (EFC):</strong> <br /><em>The <a href="http://apps.osfa.washington.edu/expected-family-contribution/dependancy-calc/?_ga=2.231312543.1601291037.1700680320-121307629.1686079790" target="_blank">EFC calculator</a> <!-- is on an external site where you--> can calculate the amount the federal government expects you and your family to contribute to your costs.</em></label> <input name="efc" type="number" value="" required="required" pattern="^([0-9]|[1-9][0-9]{0,6})$" v-model.number="form_obj.efc" /></li>
				<li>
					<label for="state"><strong>Your state residency status:</strong></label>
					<select name="state" required="required" v-model="form_obj.state">
						<option value="">Select One</option>
						<option value="WA">Washington State Resident</option>
						<option value="OTHER">Resident of Other State or Territory</option>
					</select>
					<ul>
						<li style="margin-bottom: 0;"><a id="residencyStatus"
								title="NOTE: International students are not eligible for financial aid through the University of Washington's Office of Student Financial Aid."
								href="https://www.washington.edu/financialaid/getting-started/eligibility/international-students/"
								target="_blank" rel="noopener noreferrer">Information for International students</a></li>
						<li><a href="https://www.washington.edu/financialaid/hb-1079-real-hope/" target="_blank">Financial aid for DREAMers</a></li>
					</ul>
				</li>
				<li>
					<label for="dependent"><strong>Dependency Status:</strong> <br /><em>Select dependent if you are under 24, single, are not a veteran,
						orphan, ward of the court or have dependents of your own. <br />Otherwise, select
						independent of your parents.</em></label>
					<select name="dependent" required="required" v-model="form_obj.dependent">
						<option value="">Select One</option>
						<option value="Dependent">Dependent</option>
						<option value="Independent">Independent</option>
					</select>
				</li>
				<li>
					<label for="grade"><strong>Your grade level:</strong></label>
					<select name="grade" required="required" v-model="form_obj.grade">
						<option value="">Select One</option>
						<option value="Freshman">Freshman</option>
						<option value="Sophomore">Sophomore</option>
						<option value="Junior">Junior</option>
						<option value="Senior">Senior</option>
					</select>
				</li>
				<li>
					<label for="married"><strong>Marital Status:</strong></label>
					<select name="married" required="required" v-model="form_obj.married">
						<option value="">Select One</option>
						<option value="married">Married</option>
						<option value="single">Single</option>
					</select>
				</li>
				<li>
					<label for="family_size"><strong>Your family size:</strong> <em>from the EFC calculation</em></label>
					<input name="family_size" type="number" value="" required="required" pattern="^([0-9]|[1-9][0-9]{0,6})$" v-model.number="form_obj.family_size" />
				</li>
				<li>
					<label for="parents_income"><strong>Your parents' income:</strong> if you are dependent <br /><strong>Or your and your spouse's income:</strong> <em>if you are independent</em></label>
					<input name="parents_income" type="number" value="" required="required" pattern="^([0-9]|[1-9][0-9]{0,9})$" v-model.number="form_obj.parents_income" />
				</li>
				<li>
					<label for="campus"><strong>Your campus:</strong></label>
					<select name="campus" required="required" v-model="form_obj.campus">
						<option value="">Select One</option>
						<option value="seattle">Seattle</option>
						<option value="bothell">Bothell</option>
						<option value="tacoma">Tacoma</option>
					</select>
				</li>
			</ol>
			<p style="margin-bottom: 0;"><strong>PLEASE NOTE:</strong></p>
			<ul><li style="margin-bottom: 0;">To receive financial aid you must meet all eligibility criteria as defined by federal, state and institutional rules.</li>
				<li style="margin-bottom: 0;">The estimated award does not include scholarship programs at the UW.</li>
				<li style="margin-bottom: 0;">These programs consider a variety of factors including financial need.</li></ul>
			<button class="uw-btn button-link" id="calc_estimate" v-show="show" v-on:click="calc_estimate(form_obj);">Estimate Award</button>
			<button class="uw-btn button-link" id="reset_values" v-on:click="reset_values();">Reset</button>
			
			<div class="container" v-html = "result"></div>
			<a name="awardDiv"></a>


			<br /><br />
			<h2>Important information regarding your estimated cost of attendance and financial aid</h2>
			<ul>
				<li>Your '<strong>Estimated Net Price</strong>' is calculated based on the information you provided. The
					Net Price Calculator gives estimates of your cost of attendance and net price. These estimates do
					not represent a final determination, or actual award, of financial assistance or a final net price.
					Price of attendance and financial aid availability changes year to year. These estimates shall not
					be binding on the Secretary of Education, the institution of higher education, or the State.</li>
				<li>The estimates above apply to full-time, first-time degree/certificate-seeking undergraduate students
					only.</li>
				<li>Students must complete the <strong>Free Application for Federal Student Aid (FAFSA)</strong> in
					order to determine their eligibility for Federal financial aid that includes Federal grant, loan, or
					work-study assistance. For more information on applying for Federal student aid, go to the <a
						href="https://studentaid.gov/h/apply-for-aid/fafsa" target="_blank">FAFSA webpage</a>.</li>
				<li>Students must meet the priority application date of January 15th to be considered for all financial
					aid programs. If your FAFSA is received after January 15th, you will be considered a late applicant
					and are only considered for limited types of aid.</li>
				<li>You must list the <strong>University of Washington, Code 003798</strong> as one of the colleges to
					receive the results of your FAFSA.</li>
				<li>The above estimates are not accurate for students in fee-based programs. Please contact our office
					and discuss your eligibility for aid if you are enrolled in one of these programs.</li>
				<li>When you apply for aid, the types and amounts of aid offered depend on meeting the eligibility
					criteria for specific programs.</li>
				<li>Any scholarship you are awarded from the UW or other sources will be used to calculate your
					eligibility for aid and may result in a revision of your financial aid award. At the UW, we use any
					scholarships you receive to reduce first unmet need, then loans, and then other aid if necessary.
				</li>
				<li>The cost figures used in the calculator are a combination of direct (tuition and applicable fees) as
					well as indirect (allowances for room and board, books, transportation, and miscellaneous personal
					expenses).</li>
				<li>The Net Price Calculator is not accurate for aid applicants with DREAMer status.</li>
			</ul>
			<p style="font-style: italic;">*You may be eligible for additional non-need based loans upon request. <br />Please view our <a href="https://www.washington.edu/financialaid/types-of-aid/loans/">Loans webpage</a> and/or <a href="https://studentaid.gov/">studentaid.gov</a> for more information.</p>

			<!-- <script type="text/javascript" src="https://osfa.washington.edu/wp/scripts/settings_21-22.js"></script>
<script type="text/javascript" src="https://osfa.washington.edu/wp/scripts/netpricescripts_21-22.js"></script> -->
		</div>
	</div>
</template>
<script type="text/javascript" src="https://osfa.washington.edu/wp/scripts/settings_21-22.js"></script>

<script>

// Settings
// Updated January 2022 for 2021-2022

// Total budget
const COA_SEA = 32090;
const COA_SEA_OTHER = 60588;
const COA_BOT = 32463;
const COA_BOT_OTHER = 60961;
const COA_TAC = 31040;
const COA_TAC_OTHER = 59538;

// Basic budget
// Seattle Resident Total Costs-Living On Off Campus
const SEA_BASIC = 32024;
const BOT_BASIC = 32397;
const TAC_BASIC = 30974;

// dictionary for median family income (MFI). Values get updated according to the State Need Grant (SNG) Manual. SNG is now called Washington College Grant (WCG)
// MFI is Family size and their income paired together. Ratio is stated as family size:{percent_of_maximum:income}
// The percentages are not exact.
const MFI = {
	1: {55:  30500,  60: 33500,  65: 36000,  70: 39000,  75: 42000,  100: 55500},
	2: {55:  40000,  60: 43500,  65: 47500,  70: 51000,  75: 54500,  100: 73000},
	3: {55:  49500,  60: 54000,  65: 58500,  70: 63000,  75: 67500,  100: 90000},
	4: {55:  59000,  60: 64500,  65: 69500,  70: 75000,  75: 80500,  100: 107000},
	5: {55:  68500,  60: 74500,  65: 80500,  70: 87000,  75: 93000,  100: 124000},
	6: {55:  77500,  60: 85000,  65: 92000,  70: 99000,  75: 106000, 100: 141500},
	7: {55:  79500,  60: 86500,  65: 94000,  70: 101000, 75: 108500, 100: 144500},
	8: {55:  81500,  60: 88500,  65: 96000,  70: 103500, 75: 111000, 100: 148000},
	9: {55:  83000,  60: 90500,  65: 98000,  70: 105500, 75: 113000, 100: 151000},
	10:{55:  85000,  60: 92500,  65: 100000, 70: 108000, 75: 115500, 100: 154000},
	11:{55:  86500,  60: 94500,  65: 102500, 70: 110000, 75: 118000, 100: 157500},
	12:{55:  88500,  60: 96500,  65: 104500, 70: 112500, 75: 120500, 100: 160500},
	13:{55:  90000,  60: 98500,  65: 106500, 70: 114500, 75: 123000, 100: 164000},
	14:{55:  92000,  60: 100000, 65: 108500, 70: 117000, 75: 125500, 100: 167000},
	15:{55:  93500,  60: 102000, 65: 110500, 70: 119000, 75: 127500, 100: 170500},
	16:{55:  95500,  60: 104000, 65: 113000, 70: 121500, 75: 130000, 100: 173500},
	17:{55:  97000,  60: 106000, 65: 115000, 70: 123500, 75: 132500, 100: 176500},
	18:{55:  99000,  60: 108000, 65: 117000, 70: 126000, 75: 135000, 100: 180000},
	19:{55: 100500,  60: 110000, 65: 119000, 70: 128000, 75: 137500, 100: 183000},
	20:{55: 102500,  60: 112000, 65: 121000, 70: 130500, 75: 139500, 100: 186500}
};

// SEOG is for when EFC is 0 for residents
const SEOG_RES = 300;
// SEOG when EFC is 0 for non-residents
const SEOG_NONRES = 4000;

// CAOS values for equity
// If the percents themselves change, like 60 to 55, then we need to also update the code below, near line 409.
// The variable names have the same number of letters so they align properly, Smallz, Medium, etc. - Don't you be changing them!
// Seattle CAOS 2023 - LARGER: 70%, MEDIUM: 68%, SMALLZ: 50%, MICROZ: 25%
const SEATTLE_LARGER_PER_MIN = 0;
const SEATTLE_LARGER_PER_MAX = 8000;
const SEATTLE_MEDIUM_PER_MIN = 8001;
const SEATTLE_MEDIUM_PER_MAX = 12000;
const SEATTLE_SMALLZ_PER_MIN = 12001;
const SEATTLE_SMALLZ_PER_MAX = 15000;
const SEATTLE_MICROZ_PER_MIN = 15001;
const SEATTLE_MICROZ_PER_MAX = 20000;

// Bothell CAOS - LARGER: 65%, MEDIUM: 50%, SMALLZ: 30%
const BOTHELL_LARGER_PER_MIN = 0;
const BOTHELL_LARGER_PER_MAX = 7000;
const BOTHELL_MEDIUM_PER_MIN = 7001;
const BOTHELL_MEDIUM_PER_MAX = 11000;
const BOTHELL_SMALLZ_PER_MIN = 11001;
const BOTHELL_SMALLZ_PER_MAX = 15000;
// const BOTHELL_MICROZ_PER_MIN = 10001;
// const BOTHELL_MICROZ_PER_MAX = 12000;

// Tacoma CAOS - LARGER: 65%, MEDIUM: 50%, SMALLZ: 30%
const TACOMA_LARGER_PER_MIN = 0;
const TACOMA_LARGER_PER_MAX = 7000;
const TACOMA_MEDIUM_PER_MIN = 7001;
const TACOMA_MEDIUM_PER_MAX = 11000;
const TACOMA_SMALLZ_PER_MIN = 11001;
const TACOMA_SMALLZ_PER_MAX = 15000;

// Work Study Maximum amount
const MAX_WORK_STUDY = 6600;

// Max Pell Grant value
const CURRENT_MAX_PELL = 6895;

// WCG - Formerly State Need Grant SNG now Washington College Grant
// Maximum state need grant amount
// Keys must match const MFI
const WCG_TOTALS = {
	55:  11705,
	60:  7937,
	65:  6803,
	70:  5670,
	75:  2778,
	100: 1134
};

// Purple and Gold Scholarship, Seattle only
const PURPLE_AND_GOLD = 3250;

export default {
	data: function () { return { 
		// awards: {
		// 	efc: 0,
		// 	state: 0,
		// 	state_value: 0,
		// 	dependent: "",
		// 	grade: 0,
		// 	married: "",
		// 	family_size: 0,
		// 	parents_income: 0,
		// 	campus: "",
		// 	total: 0,
		// 	CURRENT_MAX_PELL: 0,
		// 	estimate: 0 },

		net_price_calculation: {
			cost_of_attendance: 0,
			est_grants_scholarships: 0,
			est_net_cost: 0
		},

		form_obj: {
			efc: 0,
			state: "",
			dependent: "",
			grade: "",
			married: "",
			family_size: 1,
			parents_income: 0,
			campus: ""
		},

		est_need_calculation: {
			cost_of_attendance: 0,
			est_need_efc: 0,
			financial_need: 0,
			basic_budget: 0
		},
	
		awards: {
			pell: 0,
			washington_college_grant: 0,
			other_grants: 0,
			work_study: 0,
			subsidized_stafford_loan: 0,
			unsubsidized_stafford_loan: 0,
			parent_loan: 0,
			total: 0,
			purple_and_gold: 0
	},
		show: true,
		equity: 0,
		result: "",
	}},

	mounted: function () { 
		this.error = this.post = null;
		// self.loading = true;
		var self = this;
		// self.award = [];
		
		// self.calc_estimate();
		self.calc_pell();
		self.calc_washington_college_grant();
		self.calc_est_need();
		self.calc_awards(self.form_obj);
		self.update_awards_results();
		self.button_hide();
		self.reset_values();
	},
	methods: {
		calc_estimate: function(form_obj) {
			var self = this;
			self.calc_est_need();
			self.calc_awards(self.form_obj);
			self.update_awards_results();
			self.button_hide();
		},
		// calc_estimate: function(form_obj){
		// 	var self = this;
		// 	self.total = form_obj.efc + form_obj.state_value + 5 + 10;
		// 	self.result = "this is the total: " + form_obj.total;
		// 	console.log(self.result, self.total, form_obj.efc, form_obj.state_value);
		// },
		
		calc_pell: function(form_obj){
			var self = this;
			var est_pell = 0;
			if(self.form_obj.efc == 0) {
				console.log('in 1st');
				est_pell = CURRENT_MAX_PELL;
			} else if(self.form_obj.efc > 6201 && self.form_obj.efc <= 6206) {
				console.log('in 2nd');
				est_pell = 692;
			} else if(self.form_obj.efc > 6206) {
				console.log('in 3rd');
				est_pell = 0;
			} else {
				console.log('in 4th');
				est_pell = self.form_obj.efc/100;
				// if the remainder is 0, subtract 1 from the value.
				if(est_pell % 1 == 0) {
				est_pell = est_pell - 1;
				}
				// truncate the decimals off
				est_pell = Math.trunc(est_pell);
				est_pell = (est_pell*100)+50;
				est_pell = CURRENT_MAX_PELL - est_pell;
			}
			self.awards.pell = est_pell;
		},

		calc_washington_college_grant: function(remaining_need) {
		var wcg_max = 0;
		var t_mfi = [];
		var eff_mfi = 0;
		// SNG - formerly State Need Grant - now called Washington College Grant WCG
		// only award people in the 50% or less range for WCG. 0 to 50
		// MFI dictionary in settings shows the family size: income
		var self = this;
		var effective_fam_size = 1;
		// family sizes larger than 20 are set to 20
		if(self.form_obj.family_size > 20) {
			effective_fam_size = 20;
		} else {
			effective_fam_size = self.form_obj.family_size;
		}

		// if their fam size is within our dictionary range and their income is less than or equal to what is in the dictionary
		// console.log('fam size: '+effective_fam_size, 'parent income: '+form_obj.parents_income, 'MFI: '+MFI[effective_fam_size][100]);
		
		if(self.form_obj.parents_income <= MFI[effective_fam_size][100]) {
			wcg_max = 0;
			t_mfi = [];
			for (const [key, value] of Object.entries(MFI[effective_fam_size])) {
				// console.log('for: '+key+', '+value);
				
				// filter down to the cutoffs they qualify for
				if (value > self.form_obj.parents_income) {
					// console.log(key);
					t_mfi.push(parseInt(key));
				}
			}
			
			// Grab the lowest cutoff so we can select the highest maximum award
			eff_mfi = Math.min(...t_mfi);
			// console.log(t_mfi, eff_mfi);

			wcg_max = WCG_TOTALS[eff_mfi];
			// console.log('wcg_max: '+wcg_max, 'eff_mfi: '+eff_mfi);
			
			// receive up to the total
			if(remaining_need < wcg_max) {
				self.awards.washington_college_grant = remaining_need;
			} else {
				self.awards.washington_college_grant = wcg_max;
			}
		}

	},

	// Equity will funnel into Other Grants
	// If financial need is smaller than equity, use financial need
	// If equity is smaller, then we use that instead

	// If financial need is 0, they qualify for unsubsidized and the parent loan

	// no parent loan if student is independent
	// parent load is calculated if student is dependent


		calc_est_need: function() {

		// equity is a percent of cost of attendance that is met with grants and such
		// that percent depends on EFC and will differ per campus
		var self = this;
		if(self.form_obj.campus == "seattle") {
			// cost of attendance for resident
			self.est_need_calculation.cost_of_attendance = COA_SEA;
			self.est_need_calculation.basic_budget = SEA_BASIC;

			// cost of attendance for non-resident (basic budget)
			if(self.form_obj.state == "OTHER") {
				self.est_need_calculation.cost_of_attendance = COA_SEA_OTHER;
				self.est_need_calculation.basic_budget = COA_SEA_OTHER;
				self.form_obj.purple_and_gold = 0;
			} else {
				// residents are working with equity. Non-residents don't!

				if(self.form_obj.efc >= SEATTLE_LARGER_PER_MIN && self.form_obj.efc <= SEATTLE_LARGER_PER_MAX) {
					// 70%
					self.equity = Math.trunc(0.7 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= SEATTLE_MEDIUM_PER_MIN && self.form_obj.efc <= SEATTLE_MEDIUM_PER_MAX) {
					// 68%
					self.equity = Math.trunc(0.68 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= SEATTLE_SMALLZ_PER_MIN && self.form_obj.efc <= SEATTLE_SMALLZ_PER_MAX) {
					// 50%
					self.equity = Math.trunc(0.5 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= SEATTLE_MICROZ_PER_MIN && self.form_obj.efc <= SEATTLE_MICROZ_PER_MAX) {
					// 25%
					self.equity = Math.trunc(0.25 * self.est_need_calculation.basic_budget);
				}
				// update the purple and gold scholarship for Seattle while we are here
				// assuming max right now
				// awards.purple_and_gold = PURPLE_AND_GOLD;
			}
		}

		if(self.form_obj.campus == "bothell") {
			self.est_need_calculation.cost_of_attendance = COA_BOT;
			self.est_need_calculation.basic_budget = BOT_BASIC;

			// cost of attendance for non-resident
			if(self.form_obj.state == "OTHER") {
				self.est_need_calculation.cost_of_attendance = COA_BOT_OTHER;
				self.est_need_calculation.basic_budget = COA_BOT_OTHER;
				self.form_obj.purple_and_gold = 0;
			} else {

				// residents and their equity

				if(self.form_obj.efc >= BOTHELL_LARGER_PER_MIN && self.form_obj.efc <= BOTHELL_LARGER_PER_MAX) {
					// 65%
					self.equity = Math.trunc(0.65 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= BOTHELL_MEDIUM_PER_MIN && self.form_obj.efc <= BOTHELL_MEDIUM_PER_MAX) {
					// 50%
					self.equity = Math.trunc(0.5 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= BOTHELL_SMALLZ_PER_MIN && self.form_obj.efc <= BOTHELL_SMALLZ_PER_MAX) {
					// 30%
					self.equity = Math.trunc(0.3 * self.est_need_calculation.basic_budget);
					// } else if (self.form_obj.efc >= BOTHELL_MICROZ_PER_MIN && self.form_obj.efc <= BOTHELL_MICROZ_PER_MAX) {
					// 10%
					//   self.equity = Math.trunc(0.1 * self.est_need_calculation.basic_budget);
				}			
			}
		}

		if(self.form_obj.campus == "tacoma") {
			self.est_need_calculation.cost_of_attendance = COA_TAC;
			self.est_need_calculation.basic_budget = TAC_BASIC;

			// cost of attendance for non-resident

			if(self.form_obj.state == "OTHER") {
				self.est_need_calculation.cost_of_attendance = COA_TAC_OTHER;
				self.est_need_calculation.basic_budget = COA_TAC_OTHER;
			} else {

				// residents and their equity

				if(self.form_obj.efc >= TACOMA_LARGER_PER_MIN && self.form_obj.efc <= TACOMA_LARGER_PER_MAX) {
					// 65%
					self.equity = Math.trunc(0.65 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= TACOMA_MEDIUM_PER_MIN && self.form_obj.efc <= TACOMA_MEDIUM_PER_MAX) {
					// 50%
					self.equity = Math.trunc(0.5 * self.est_need_calculation.basic_budget);
				} else if (self.form_obj.efc >= TACOMA_SMALLZ_PER_MIN && self.form_obj.efc <= TACOMA_SMALLZ_PER_MAX) {
					// 30%
					self.equity = Math.trunc(0.3 * self.est_need_calculation.basic_budget);
					// } else if (self.form_obj.efc >= TACOMA_10_PER_MIN && self.form_obj.efc <= TACOMA_10_PER_MAX) {
					// 10%
					//   self.equity = Math.trunc(0.1 * self.est_need_calculation.basic_budget);
				}
			}
		}
		self.est_need_calculation.est_need_efc = self.form_obj.efc;

		// Financial need = cost of attendance - EFC
		if(self.est_need_calculation.cost_of_attendance >= self.est_need_calculation.est_need_efc) {
			self.est_need_calculation.financial_need = self.est_need_calculation.cost_of_attendance - self.est_need_calculation.est_need_efc;
		} else {
			self.est_need_calculation.financial_need = 0;
		}
	},

		calc_awards: function(form_obj) {
		// pell
		this.calc_pell();
		var self = this;
		// projected award will check against financial need
		var projected_award = self.awards.pell;
		// var fin_need = self.est_need_calculation.financial_need;

		// only residents can get Washington College Grant - WCG
		// Formerly State Need Grant - SNG
		if(self.form_obj.state == "WA" && projected_award < self.equity) {
			// state need grant
			if(form_obj.efc <= 17000) {
				this.calc_washington_college_grant(self.equity);
			}
		}
		
		projected_award += self.awards.washington_college_grant;

		if(self.form_obj.state == "WA" && projected_award < self.equity) {
			// calculate SEOG award for residents
			if(form_obj.efc <= 5576) {
				self.awards.other_grants = SEOG_RES;
			}
		} else if(self.form_obj.state == "OTHER") {
			// SEOG for non-residents
			self.awards.other_grants = 0;
			if(form_obj.efc == 0) {
				self.awards.other_grants += SEOG_NONRES;
			} else if(form_obj.efc >= 1 && form_obj.efc <= 5576) {
				self.awards.other_grants += 2100;
			}
		}

		// if student still has equity need after the grants, it gets funneled into other grants.
		// we are subtracting other grants specifically here because of how we're trying to get remaining need
		if(self.est_need_calculation.financial_need > 0 && self.equity - projected_award - self.awards.other_grants > 0) {
			if(self.form_obj.state == "WA") {
				var remainder = self.equity - projected_award - self.awards.other_grants;
				self.awards.other_grants += remainder;
				// grants need to stop at 60% of budget/equity
			}
		}

		projected_award += self.awards.other_grants;
		// Work Study check - cuts off after 1500 efc
		// Work Study would never be used to meet equity
		// If there is still need after equity is met, then student would need work study
		// subtract equity from need to check:
		if(self.est_need_calculation.financial_need - self.equity > 0 && form_obj.efc <= 1500) {
			// calculate work study
			// receive award up to 5400, limited by need
			var need = self.est_need_calculation.financial_need - projected_award;
			if(need > 0 && need <= MAX_WORK_STUDY) {
				self.awards.work_study = need;
			} else {
				self.awards.work_study = MAX_WORK_STUDY;
			}
		}

		projected_award += self.awards.work_study;

		// If financial need is 0, student qualifies for unsubsidized and the parent loan
		// Max Subsidized Student Loans
		if(self.est_need_calculation.financial_need - projected_award > 0 ) {

			var remaining_need = self.est_need_calculation.financial_need - projected_award;
			var max_subsidized_loan = 0;

			if(form_obj.grade == "Freshman") {
				max_subsidized_loan = 3500;
			}

			if(form_obj.grade == "Sophomore") {
				max_subsidized_loan = 4500;
			}

			if(form_obj.grade == "Junior" || form_obj.grade == "Senior") {
				max_subsidized_loan = 5500;
			}

			if(max_subsidized_loan > remaining_need) {
				self.awards.subsidized_stafford_loan = remaining_need;
			} else {
				self.awards.subsidized_stafford_loan = max_subsidized_loan;
			}
		}
		projected_award += self.awards.subsidized_stafford_loan;

		// Max Unsubsidized Student Loans - student still has need or has greater EFC than Cost of Attendance
		if(self.est_need_calculation.financial_need - projected_award > 0 || form_obj.efc >= self.est_need_calculation.cost_of_attendance) {
			// max unsubsidized loan is the max limit that students can have
			var max_unsubsidized_loan = 0;
			var unsub_loan_minus_sub = 0;
			if(form_obj.dependent == "Dependent") {
				// if they have subsidized loans already, this number changes!
				if(form_obj.grade == "Freshman") {
					max_unsubsidized_loan = 5500;
				}
				if(form_obj.grade == "Sophomore") {
					max_unsubsidized_loan = 6500;
				}
				if(form_obj.grade == "Junior" || form_obj.grade == "Senior") {
					max_unsubsidized_loan = 7500;
				}
			} else if (form_obj.dependent == "Independent") {
				if(form_obj.grade == "Freshman") {
					max_unsubsidized_loan = 9500;
				}
				if(form_obj.grade == "Sophomore") {
					max_unsubsidized_loan = 10500;
				}
				if(form_obj.grade == "Junior" || form_obj.grade == "Senior") {
					// juniors and seniors get more
					max_unsubsidized_loan = 12500;
				}
			}
			unsub_loan_minus_sub = max_unsubsidized_loan - self.awards.subsidized_stafford_loan;
			var loan_need = self.est_need_calculation.financial_need - projected_award;
			if(unsub_loan_minus_sub >= loan_need) {
				self.awards.unsubsidized_stafford_loan = loan_need;
				if(form_obj.efc > self.est_need_calculation.cost_of_attendance) {
					self.awards.unsubsidized_stafford_loan = max_unsubsidized_loan;
				}
			} else {
				self.awards.unsubsidized_stafford_loan = max_unsubsidized_loan - self.awards.subsidized_stafford_loan;
			}

		}

		projected_award += self.awards.unsubsidized_stafford_loan;

		// parent loan (only if student is dependent)
		// PLUS - Parent Loan to Undergraduate Student
		// Usually, if a student has need, they are offered PLUS up to need minus any other aid offered.

		if(form_obj.dependent == "Dependent") {
			var plus = 0;
			if(self.est_need_calculation.financial_need - projected_award > 0) {
				plus = self.est_need_calculation.financial_need - projected_award;
			} 
			// When a student has 0 need (budget - EFC = 0) they get unsub loan up to the limit 
			// and a parent loan up to the cost of attendance
			if(self.est_need_calculation.financial_need <= 0 && form_obj.efc > self.est_need_calculation.cost_of_attendance) {
				plus = self.est_need_calculation.cost_of_attendance - projected_award;
			}

			self.awards.parent_loan = plus;
		}
		projected_award += self.awards.parent_loan;
		self.awards.total = projected_award;
		self.update_awards_results();
	},

	update_awards_results: function() {
		var self = this;
		if(self.awards.other_grants > self.est_need_calculation.financial_need && self.awards.other_grants > 0) {
			self.awards.other_grants = self.est_need_calculation.financial_need;
		}
		let grants_scholarships = self.awards.other_grants+self.awards.washington_college_grant+self.awards.purple_and_gold+self.awards.pell;
		if(grants_scholarships > self.est_need_calculation.financial_need && grants_scholarships > 0) {
			grants_scholarships = self.est_need_calculation.financial_need;
		}
		if(self.awards.unsubsidized_stafford_loan < 0) { self.awards.unsubsidized_stafford_loan = 0; }

		let est_net_cost = self.est_need_calculation.cost_of_attendance - grants_scholarships;
		// tie together the HTML

		self.result = "<div id='award_result'><h2 style='font-size: 2em; padding-top: 2rem;'>Your Estimated Results</h2><table id='estimator' style='border: 1px solid grey; margin-left: 25px;' width='100%' cellspacing='10' cellpadding='0' class='table table-striped'><tbody><tr><td colspan='2'><h3 style='margin: .5em 0 0; font-weight: 600;'>Your Estimated Need Calculation:</h3></td></tr><tr>"+

			"<td>"+self.formatCurrency(self.est_need_calculation.cost_of_attendance)+"</td>"+
			
			"<td><a href='https://www.washington.edu/financialaid/getting-started/student-budgets/' target='_blank' rel='noopener noreferrer'>Cost of Attendance</a></td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.est_need_calculation.est_need_efc)+"</td>"+
			
			"<td>Expected Family Contribution (EFC)</td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.est_need_calculation.financial_need)+"</td>"+
			
			"<td><a href='https://www.washington.edu/financialaid/getting-started/how-aid-is-determined/' target='_blank' rel='noopener noreferrer'>Financial Need</a></td></tr><tr class='separator'><td colspan='2'></td></tr><tr><td colspan='2'><h3 style='margin: .5em 0 0; font-weight: 600;'>Your Estimated Awards:</h3></td></tr><tr><td class='money'><h3>Amount</h3></td><td><h3>Type of Award</h3></td></tr><tr id='purpGoldList' style='display: none;'>"
			
			+"<td>"+self.formatCurrency(self.awards.purple_and_gold)+"</td>"+

			"<td><a title='The Purple and Gold Scholarship is awarded to non-resident students attending the Seattle campus with a GPA of 3.4 or greater' href='http://www.washington.edu/students/osfa/ugaid/student.loan.guide.html' target='_blank' rel='noopener noreferrer'>Purple and Gold Scholarship</a></td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.awards.pell)+"</td>"+
			
			"<td><a href='https://www.washington.edu/financialaid/types-of-aid/grants/' target='_blank' rel='noopener noreferrer'>Federal Pell Grant</a></td></tr><tr>"+

			"<td>"+self.formatCurrency(self.awards.washington_college_grant)+"</td>"+
			
			"<td><a href='https://www.washington.edu/financialaid/types-of-aid/grants/' target='_blank' rel='noopener noreferrer'>Washington College Grant</a></td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.awards.other_grants+self.awards.purple_and_gold)+"</td>"+"<td><a href='https://www.washington.edu/financialaid/types-of-aid/grants/' target='_blank' rel='noopener noreferrer'>Other Grants</a></td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.awards.work_study)+"</td>"+
			
			"<td><a href='https://www.washington.edu/financialaid/types-of-aid/work-study/' target='_blank' rel='noopener noreferrer'>Work Study</a></td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.awards.subsidized_stafford_loan)+"</td>"+"<td><a href='https://www.washington.edu/financialaid/types-of-aid/loans/federal-and-university-loans/' target='_blank' rel='noopener noreferrer'>Federal Subsidized Stafford Loan</a></td></tr><tr>"+

			"<td>"+self.formatCurrency(self.awards.unsubsidized_stafford_loan)+"</td>"+"<td><a href='https://www.washington.edu/financialaid/types-of-aid/loans/federal-and-university-loans/' target='_blank' rel='noopener noreferrer'>Federal Unsubsidized Stafford Loan</a>*</td></tr><tr>"+
			"<td>"+self.formatCurrency(self.awards.parent_loan)+"</td>"+"<td><a href='https://www.washington.edu/financialaid/types-of-aid/loans/parent-loans/' target='_blank' rel='noopener noreferrer'>Federal Parent Loan</a>*</td></tr><tr>"+
			
			"<td>"+self.formatCurrency(self.awards.total)+"</td>"+"<td><strong>Total Estimated Award Eligibility</strong></td></tr><tr><td colspan='2'><h3 style='margin: .5em 0 0; font-weight: 600;'>Your Net Price Calculation:</h3></td></tr><tr>"+
			"<td>"+self.formatCurrency(self.est_need_calculation.cost_of_attendance)+"</td>"+"<td><a id='campus' href='https://www.washington.edu/financialaid/getting-started/student-budgets/' target='_blank' rel='noopener noreferrer'>Cost of Attendance</a></td></tr><tr>"+
			"<td>"+self.formatCurrency(grants_scholarships)+"</td>"+"<td>Estimated Grants and/or Scholarships</td></tr><tr>"+
			"<td>"+self.formatCurrency(est_net_cost)+"</td>"+"<td>Estimated Net Cost</td></tr><tr class='separator'><td colspan='2'><hr></td></tr></tbody></table></div>";
	},

	// estimator: function(e) {
	// 	e.preventDefault();
	// 	reset_values();

	// 	// $("input:invalid").css("border", "2px dashed red");
	// 	// $("select:invalid").css("border", "2px dashed red");
	// 	if(is_valid()) {
	// 		calc_est_need();

	// 		// now calculate the awards
	// 		calc_awards();

	// 		// update the values
	// 		update_awards_results();
	// 	}
	// 	// validation check
	// 	// make sure all of the entries are filled out
	// 	// use :valid https://developer.mozilla.org/en-US/docs/Learn/HTML/Forms/Form_validation
	// },

// NOTE: Redue validator in VUE

	// is_valid: function() {
	// 	var valid = true;
	// 	var efc_int = parseInt($("input[name=efc]")[0].value);
	// 	if (isNaN(efc_int) || efc_int < 0) {
	// 		valid = false;
	// 	} else {
	// 		form_obj.efc = efc_int;
	// 	}

	// 	if ($("select[name=state]")[0].value == "") {
	// 		valid = false;
	// 	} else {
	// 		form_obj.state = $("select[name=state]")[0].value;
	// 	}

	// 	if ($("select[name=dependent]")[0].value == "") {
	// 		valid = false;
	// 	} else {
	// 		form_obj.dependent = $("select[name=dependent]")[0].value;
	// 	}

	// 	if ($("select[name=grade]")[0].value == "") {
	// 		valid = false;
	// 	} else {
	// 		form_obj.grade = $("select[name=grade]")[0].value;
	// 	}

	// 	if ($("select[name=married]")[0].value == "") {
	// 		valid = false;
	// 	} else {
	// 		form_obj.married = $("select[name=married]")[0].value;
	// 	}

	// 	var family_size = parseInt($("input[name=fam_size]")[0].value);
	// 	if (isNaN(family_size) || family_size < 0) {
	// 		valid = false;
	// 	} else {
	// 		form_obj.family_size = family_size;
	// 	}

	// 	var parents_income = parseInt($("input[name=p_income]")[0].value);
	// 	if (isNaN(parents_income) || parents_income < 0) {
	// 		valid = false;
	// 	} else {
	// 		form_obj.parents_income = parents_income;
	// 	}

	// 	if ($("select[name=campus]")[0].value == "") {
	// 		valid = false;
	// 	} else {
	// 		form_obj.campus = $("select[name=campus]")[0].value;
	// 	}

	// 	return valid;
	// },
	
		formatCurrency: function(strValue) {
		var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',});
		return formatter.format(strValue);
	},
		reset_values: function(){
			var self = this;
			// self.loading = true;
			self.awards = [];
			self.efc = 0;
			self.state = 0;
			self.state_value = 0;
			self.dependent = "";
			self.grade = 0;
			self.married = "";
			self.family_size = 0;
			self.parents_income = 0;
			self.campus = "";
			self.total = 0;
			self.result = "";

			self.awards.parent_loan = 0;
			self.awards.other_grants = 0;
			self.awards.pell = 0;
			self.awards.purple_and_gold = 0;
			self.awards.washington_college_grant = 0;
			self.awards.subsidized_stafford_loan = 0;
			self.awards.unsubsidized_stafford_loan = 0;
			self.awards.total = 0;
			self.awards.work_study = 0;
			self.form_obj.campus = "";
			self.form_obj.dependent = "";
			self.form_obj.efc = 0;
			self.form_obj.family_size = 0;
			self.form_obj.parents_income = 0;
			self.form_obj.grade = "";
			self.form_obj.married = "";
			self.form_obj.state = "";
			self.net_price_calculation.cost_of_attendance = 0;
			self.est_need_calculation.cost_of_attendance = 0;
			self.net_price_calculation.est_grants_scholarships = 0;
			self.net_price_calculation.est_net_cost = 0;
			this.show = true;
		},

		button_hide: function(){ 
			this.show = false; }
	}
}

/*
 Some rules about calculating this financial estimate:
 COA = Cost of Attendence. Differs by in/out of state.
 EFC = Expected Family Conribution, via outside calculator
 FN = Financial Need. This COA - EFC.
 Equity = Eligibility in terms of loans. Smallest value of (0.61 * COA) or FN

 Awards are given in this order:
 1) Equity
 - PELL
 - College Grant *Formerly State Need
 - SEOG
 - Tuition Exemption, only for WA residents
 2) FN
 - Loans
 - Work Study
 */

</script>

<style scoped>

#app.alert.alert-uw .alert.alert-uw {
	color: black !important;
	background-color: #e8e3d3 !important;
	border-color: #e8e3d3 !important;
	border-radius: 0 !important;
}

#app.content .content {
	font-family: 'Open Sans', sans-serif;
}

#app.card {
	border-radius:0;
}

#app.card-header .card {
	border-radius:0;
}

.card-header {
	background-color: #4b2e83;
	border-radius: 0 !important;
	color: white;
	font-family: "Encode Sans Compressed",sans-serif;
	/* padding-bottom:.5rem; */
}

#app .card-title {
	font-weight:300;
	margin:0;
}
#app .card-subtitle {
	color:#ddd !important;
	padding-top:.5rem;
}
#app .card-body {
	border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

#app tr:nth-child(2n) {
    background-color: #e8e3d3;
}

#app .table td {
	border:none;
}

#app .table th {
	border:none;
	border-bottom:2px solid rgba(0, 0, 0, 0.125);
}

#app .btn.btn-outline-danger {
	background-color:white;
	color:#dc3545;
}

#app .btn.btn-outline-danger:hover {
	color:white;
	background-color:#dc3545;
}
.card-title {
	font-weight:300;
	margin:0;
}
.card-subtitle {
	color:#ddd !important;
	padding-top:.5rem;
}
.card-body {
	border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}


ul, ol {
	padding: .5rem 2rem 0;
}

p {
	margin:.5rem 0;	
}
li {
	margin: 0 0 1.5rem 0;
}
ol li::marker {
	font-weight: bold;
}
a {
}
input, select { display: block; margin: .5rem 0; }

.uw-btn {
	background: #4b2e83;
	border: solid 3px gray;
	border-radius: .2rem;
	color: #ffffff;
	font-size: 1.5rem;
	margin: 1rem 0 0 2rem;
	padding: .5rem 1.2rem;
	text-transform: none;
}

.section-label { 
	background-color: #4b2e83;
	color: white;
	font-weight: 600;
	margin: 20px 0 8px -30px;
	padding: 4px 0 3px 30px;
}

/* button.uw-btn::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 55px;
    height: 55px;
    right: -55px;
    top: 50%;
    margin-top: -28px;
    background: url(../assets/svg/uw-sprite.svg) no-repeat -36px -475px transparent;
} */

.content {
	padding-bottom:4rem;
}

.document-list {
	padding-bottom:2rem;
}

.card-text {
	white-space:pre-wrap;
}

.test-panel {
	position:fixed;
	top:1rem;
	right:1rem;
	padding:1rem;
	border:1px solid #ccc;
	background-color:beige;
	max-width:20rem;
}

.folder-message {
	text-align:left;
}

.folder-message-additional {
	text-align:left;
	margin-bottom:2rem;
	white-space:pre-wrap;
}

.alert.alert-uw {
	color: black;
	background-color: #e8e3d3 !important;
	border-color: #b7a57a;
	border-radius: 0;
}
/* .test-panel pre {
	word-wrap: normal;
	overflow-wrap: normal;
	max-width:19rem;
	display:inline-block;
} */

.folder-message {
	text-align:center;
}

.folder-message-additional {
	text-align:center;
	margin-bottom:2rem;
}

label { display: inline; }

.loading-panel {
	position:fixed;
	top:40%;
	left:0;
	width:100%;
	text-align:center;
	/* padding:1rem; */
	/* border:1px solid #ccc; */
	/* background-color:white; */
}

.loader,
.loader:after {
	border-radius: 50%;
	width: 10em;
	height: 10em;
}
.loader {
	margin: 0 auto;
	font-size: 10px;
	position: relative;
	text-indent: -9999em;
	border-top: 1.1em solid rgba(255, 255, 255, 0.2);
	border-right: 1.1em solid rgba(255, 255, 255, 0.2);
	border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
	border-left: 1.1em solid #000;
	-webkit-transform: translateZ(0);
	-ms-transform: translateZ(0);
	transform: translateZ(0);
	-webkit-animation: load8 1.1s infinite linear;
	animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
	0% { -webkit-transform: rotate(0deg);
	transform: rotate(0deg);}
	100% { -webkit-transform: rotate(360deg); 
	transform: rotate(360deg); }
}
@keyframes load8 {
	0% { -webkit-transform: rotate(0deg);
	transform: rotate(0deg); }
	100% { -webkit-transform: rotate(360deg);
	transform: rotate(360deg); }
}
</style>